/**
 * GHL 7.2 — filtros de la lista de leads, con los nombres que el backend LEE.
 *
 * `leadsApi.getAll` mandaba `assignedAgentId`, `priority`, `tags` y fechas, y
 * `lead.service findAll` sólo leía status/stage/source/assignedToId/search: el
 * resto se ignoraba y la lista volvía sin filtrar. El backend ahora lee
 * `assignedToId` (o 'none'), `priority`, `tagId` y `createdFrom`/`createdTo`
 * (lead-filtros.ts), y esto es lo que los arma.
 */

export interface FiltrosExtra {
  source?: string;
  assignedToId?: string; // uuid del USUARIO, o 'none' = sin asignar
  priority?: string;
  tagId?: string;
  createdFrom?: string; // YYYY-MM-DD
  createdTo?: string; // YYYY-MM-DD (incluye ese día)
}

export const CLAVES_FILTRO: (keyof FiltrosExtra)[] = [
  'source',
  'assignedToId',
  'priority',
  'tagId',
  'createdFrom',
  'createdTo',
];

export const agregarFiltros = (params: URLSearchParams, f?: FiltrosExtra | null): URLSearchParams => {
  for (const k of CLAVES_FILTRO) {
    const v = f?.[k];
    if (typeof v === 'string' && v.trim()) params.append(k, v.trim());
  }
  return params;
};

/** Cuántos filtros de esta fila están puestos (para «Limpiar (n)»). */
export const cuantosFiltros = (f?: Record<string, unknown> | null): number =>
  CLAVES_FILTRO.filter((k) => typeof f?.[k] === 'string' && (f?.[k] as string).trim()).length;

/** Los filtros sin los de esta fila (búsqueda y etapa se conservan). */
export const sinFiltrosExtra = <T extends Record<string, unknown>>(f: T): T => {
  const c = { ...f };
  for (const k of CLAVES_FILTRO) delete (c as Record<string, unknown>)[k];
  return c;
};
